export default {
  methods: {
    formatDate (dateString: string, options: Intl.DateTimeFormatOptions = { dateStyle: 'medium' }, lang = 'cs-CZ') {
      if (dateString !== '' && dateString != null && dateString !== undefined) {
        const date = new Date(dateString)
        return new Intl.DateTimeFormat(lang, options).format(date)
      }
    },
    formatUnfilteredOrderByDate (date : string) {
      const newDate = new Date(date)
      newDate.setHours(12, 0, 0, 0) // always 12:00:00, to show on orderby for unfiltered orders
      return this.formatDateAndTime(newDate.toISOString(), true, true)
    },
    formatTankOrderByDate (date : string) {
      const newDate = new Date(date)
      newDate.setHours(16, 0, 0, 0) // always 12:00:00, to show on orderby for unfiltered orders
      return this.formatDateAndTime(newDate.toISOString(), true, true)
    },
    formatDateAndTime (dateString: string, hideSeconds?: boolean, hideMonthZeroes?: boolean) {
      if (dateString) {
        const date = new Date(dateString)
        return new Intl.DateTimeFormat('cs-CZ', { dateStyle: hideMonthZeroes ? 'medium' : 'short', timeStyle: hideSeconds ? 'short' : 'medium' }).format(date)
      }
    },
    formatCurrency (currency: number) {
      if (localStorage.getItem('store') && localStorage.getItem('store')?.includes('SK')) {
        return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'EUR' }).format(currency)
      }
      return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK' }).format(currency)
    },
    formatPercentage (percentage: number) {
      return new Intl.NumberFormat('cs-CZ', { style: 'percent', maximumFractionDigits: 1 }).format(percentage / 100)
    },
    minusValue (value: number) {
      return value > 0 ? -value : value
    },

    formateDateWithoutLocale (date: string) {
      if (date && typeof date === 'string') {
        const structuredDate = new Date(date)
        if (structuredDate) {
          return `${('0' + structuredDate.getDate()).slice(-2)}.${('0' + (structuredDate?.getMonth() + 1))?.slice(-2)}.${structuredDate.getFullYear()}`
        }
      }
      return ''
    },

    formateDateAndTimeWithoutLocale (date: string) {
      if (date && typeof date === 'string') {
        const structuredDate = new Date(date)
        if (structuredDate) {
          return `${('0' + structuredDate.getDate()).slice(-2)}.${('0' + (structuredDate?.getMonth() + 1))?.slice(-2)}.${structuredDate.getFullYear()} ${('0' + structuredDate.getHours()).slice(-2)}:${('0' + structuredDate.getMinutes()).slice(-2)}`
        }
      }
      return ''
    }
  }
}
